import getPkce from 'oauth-pkce';

type PkceInfo = {
  verifier: string;
  challenge: string;
};

const getPkceInfo = async (): Promise<PkceInfo> => {
  return new Promise((resolve) => {
    getPkce(43, (error, { verifier, challenge }) => {
      if (error) throw error;
      resolve({ verifier: verifier, challenge: challenge });
    });
  });
};

export default getPkceInfo;
